import * as echarts from 'echarts';

// https://echarts.apache.org/examples/en/editor.html?c=bar-simple&lang=ts

export class ChartPopulationOne {
    private readonly chartRoot: HTMLDivElement;
    private myChart: echarts.ECharts;
    private options: echarts.EChartsOption;

    constructor(chartRoot: HTMLDivElement, defaultOptions: echarts.EChartsOption) {
        this.chartRoot = chartRoot;
        this.myChart = echarts.init(chartRoot);
        this.options = defaultOptions;
    }

    render(options: echarts.EChartsOption | null = null): void {
        if (options !== null) {
            this.options = options;
        }
        this.myChart.setOption(this.options);
    }
}
